import { TransType } from 'hooks/useTranslations';

export enum RETURN_RULE_ID {
  TIMEFRAME = 'Timeframe',
  SIX_DAYS = '6Days',
  NON_ELIGIBLE = 'Non Eligible',
}

export const getReturnsMessage = (
  translate: TransType,
  returnRuleId?: RETURN_RULE_ID
) => {
  switch (returnRuleId) {
    case RETURN_RULE_ID.TIMEFRAME:
      return translate('returnsTimeFrame', { days: 15 });

    case RETURN_RULE_ID.SIX_DAYS:
      return translate('returnsTimeFrame', { days: 6 });

    default:
      return translate('returnShipping');
  }
};
